<template>
  <div style="margin-top: 0px">

    <el-row
      justify="space-around"
      :gutter="10"
    >
      <el-col :span="21">
        <el-card style="margin-left: 10px;margin-top: 10px;">
          <div
            slot="header"
            class="clearfix"
          >
            <span>常用功能</span>
          </div>
          <div style="background: rgb(236, 245, 255);display: flex; height:66px;">
            <div
              v-for="item in buttonList"
              v-bind:key="item.name"
              style="margin: 10px;"
            >
              <!-- 这里触发点击事件 -->
              <el-button
                display:
                flex
                type='primary'
                @click="go(item.path)"
              >{{item.name}}</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="2.5">
        <el-card
          class="welcome-card note"
          style="margin-left: 10px;margin-top: 10px"
        >
          <div slot="header">
            <span>手机扫一扫直达</span>
          </div>
          <img
            src="../assets/login.png"
            height="64"
            width="64"
          />
          <!-- </div> -->
        </el-card>
      </el-col>

    </el-row>
    <el-row class="panel-group">
      <el-col>
        <el-card
          class="welcome-card note"
          style="width: 98%; margin-top: 0px"
        >
          <div
            slot="header"
            class="clearfix"
          >
            <span>公告</span>
          </div>
          <div style="background: rgb(236, 245, 255);display: flex;">
            <!--列表-->
            <el-table
              :data="GGListInfo"
              highlight-current-row
              v-loading="listLoading"
              :cell-style="cellStyle"
              @row-click="selectCurrentRow2"
            >
              <el-table-column
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column
                prop="btitle"
                label="标题"
                style="color:blue"
                width="400"
                :formatter="short"
                sortable
              >
              </el-table-column>
              <el-table-column
                prop="bsubmitter"
                label="发布人"
                sortable
              >
              </el-table-column>
              <el-table-column
                prop="bCreateTime"
                label="发布时间"
                :formatter="dateFormat1"
                sortable
              >
              </el-table-column>
            </el-table>

          </div>
          <!--预览界面-->
          <el-dialog
            title="公告"
            :visible.sync="readFormVisible"
            v-model="readFormVisible"
            :close-on-click-modal="false"
          >
            <el-form
              :model="readForm"
              label-width="80px"
              ref="readForm"
            >
              <el-form-item
                label="标题"
                prop="btitle"
              >
                <el-input
                  disabled
                  v-model="readForm.btitle"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="创建人"
                    prop="bsubmitter"
                  >
                    <el-input
                      disabled
                      v-model="readForm.bsubmitter"
                      auto-complete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="创建时间"
                    prop="bCreateTime"
                  >
                    <el-input
                      disabled
                      v-model="readForm.bCreateTime"
                      auto-complete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item
                label="正文"
                prop="bcontent"
              >
                <div>
                  <mavon-editor
                    v-model="readForm.bcontent"
                    :subfield="false"
                    :defaultOpen="'preview'"
                    :toolbarsFlag="false"
                    :editable="false"
                    :scrollStyle="true"
                    :ishljs="true"
                    ref="md"
                    style="min-height: 600px"
                  />
                </div>
              </el-form-item>
            </el-form>
          </el-dialog>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Vue from "vue";
import VCharts from "v-charts";
import { mavonEditor } from 'mavon-editor'
Vue.use(VCharts);

import applicationUserManager from "../Auth/applicationusermanager";
import {
  getServerInfo,
  getAccessLogs,
  getIds4UsersGrow,
  getActiveUsers,
  getAchieveUsers_IS4,
  getPublishBlogListPage
} from "../api/api";

export default {
  name: "Welcome",
  components: { mavonEditor },
  data() {
    return {
      url: '../../assets/login.png',
      listLoading: false,
      welcomeInitData: {},
      serverInfo: {},
      extend: {
        series: {
          label: {
            normal: {
              show: true,
            },
          },
        },
      },
      lineChartDataIDS4: {
        columns: [],
        rows: [],
        today: 0,
      },
      lineChartSettings7Day: {
        metrics: ["count"],
        dimension: ["date"],
      },
      lineChartMarkPoint: {
        data: [
          {
            name: "最大值",
            type: "max",
          },
          {
            name: "最小值",
            type: "min",
          },
        ],
      },
      buttonList: [
        {
          name: "报销申请单",
          icon: "max",
          path: "/Reimbursement/Reimbursement",
        },
        {
          name: "报销单",
          icon: "max",
          path: "/ListReimbursement/ListReimbursement",
        },
        {
          name: "我的发票",
          icon: "max",
          path: "/System/MyRB",
        },
      ],
      GGListInfo: [],
      readForm: {
      },
      readFormVisible: false,//公告预览界面是否显示
    };
  },
  methods: {
    go(path) {
      this.$router.replace({
        path: path,
      });
    },
    getTypeName(count) {
      if (count >= 10 && count < 50) {
        return "warning";
      }
      if (count < 10) {
        return "primary";
      }
      return "";
    },
    getBck(index) {
      return `background: rgb(${43 + index * 20}, ${148 + index * 10
        }, 255) none repeat scroll 0% 0%;`;
    },
    toLogs() {
      this.$router.replace({
        path: "/Logs/Index",
      });
    },
    selectCurrentRow2(val) {

      this.readForm = Object.assign({}, val);
      this.readForm.bCreateTime = this.dateFormat3(this.readForm.bCreateTime);
      this.readFormVisible = true;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {//根据报警级别显示颜色
      if (columnIndex === 1) {
        return 'color:blue'
      }
    },
    //处理文字过长
    short: function(row, column) {
      return row.btitle.substr(0, 20) + '...';
    },
    //时间格式化1
    dateFormat1: function(row, column) {
      var t = new Date(row.bCreateTime);//row 表示一行数据, updateTime 表示要格式化的字段名称
      return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    },
    //时间格式化2
    dateFormat3: function(date) {

      if (typeof date === 'undefined') return null;
      var date = new Date(date);//row 表示一行数据, updateTime 表示要格式化的字段名称
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m + s;
    },
  },
  mounted() {
    var curTime = new Date();
    if (window.localStorage.TokenExpire) {
      var expiretime = new Date(Date.parse(window.localStorage.TokenExpire));
      if (curTime >= expiretime) {
        if (global.IS_IDS4) {
          applicationUserManager.login();
        } else {
          this.$router.push("/login");
        }
      }
    } else {
      if (global.IS_IDS4) {
        applicationUserManager.login();
      } else {
        this.$router.push("/login");
      }
    }

    // getAchieveUsers_IS4({}).then((res) => {
    //   this.lineChartDataIDS4 = res.data.response;
    // });

    getServerInfo({}).then((res) => {
      this.serverInfo = res.data.response;
    });

    // getActiveUsers({}).then((res) => {
    //   this.welcomeInitData = res.data.response;
    // });

    getPublishBlogListPage().then((res) => {
      this.GGListInfo = res.data.data;
    });
  },
};
</script>

<style scoped>
.bg-blue-sub-item {
  max-width: 120px !important;
  height: 50px;
  float: left;
  color: #fff;
  font-size: 15px;
  line-height: 50px;
  padding: 0 10px;
}
.note .text {
  font-size: 14px;
}

.note .item {
  margin-bottom: 18px;
}

.buttonlist {
  display: flex;
  justify-content: flex-start;
}
</style>

<style scoped>
.panel-group {
  margin-top: 8px;
  margin-left: 10px;
  margin-bottom: 18px;
  width: 100%;
  float: left;
}
.card-panel-col {
  margin-bottom: 32px;
  width: 115px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-left: 15px;
  float: right;
}

.card-panel {
  height: 108px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}

.card-panel .card-panel-icon-wrapper {
  color: #fff;
}

.card-panel .card-panel .icon-people {
  background: #40c9c6;
}

.card-panel .card-panel .icon-message {
  background: #36a3f7;
}

.card-panel .card-panel .icon-money {
  background: #f4516c;
}

.card-panel .card-panel .icon-shopping {
  background: #34bfa3;
}

.card-panel .icon-people {
  color: #40c9c6;
}

.card-panel .icon-message {
  color: #36a3f7;
}

.card-panel .icon-money {
  color: #f4516c;
}

.card-panel .icon-shopping {
  color: #34bfa3;
}

.card-panel .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 16px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}

.card-panel .card-panel-icon {
  float: left;
  font-size: 48px;
}

.card-panel .card-panel-description {
  float: left;
  font-weight: bold;
  margin-left: 30px;
  margin-top: 20px;
}
.card-panel .card-panel-description .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}

.card-panel .card-panel-description .card-panel-num {
  font-size: 36px;
  color: #f4516c;
}
.extoday {
  cursor: pointer;
}
.card-acuser-num {
  font-size: 36px;
  color: #40c9c6;
}
.bg-blue-sub-item /deep/ .el-badge__content.is-fixed {
  top: 5px !important;
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
  .card-panel-icon-wrapper .svg-icon {
    display: block;
    margin: 14px auto !important;
    float: none !important;
  }
}
</style>
